import React from 'react';
import { ExternalLink, Phone, MessageSquare, FileText, AlertCircle } from 'lucide-react';
export function LinksAndResources() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-959">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-960">
        {/* Page Header */}
        <div className="text-center mb-12" data-id="element-961">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-962">
            LINKS & RESOURCES
          </h1>
        </div>

        {/* ADRE and other Useful Links Section */}
        <div className="mb-12" data-id="element-963">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-964">
            ADRE and other Useful Links
          </h2>

          {/* Student Log-In Link */}
          <div className="mb-6" data-id="element-965">
            <p className="text-base" data-id="element-966">
              <span className="text-green-600 font-bold italic" data-id="element-967">
                Go Back To Student Log-In
              </span>{' '}
              <a href="http://www.desertsageseminars.com/Home.html" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700 underline" data-id="element-968">
                http://www.desertsageseminars.com/Home.html
              </a>
            </p>
          </div>

          {/* ADRE Contact */}
          <div className="mb-6" data-id="element-969">
            <p className="text-base font-bold italic" data-id="element-970">
              Arizona Department of Real Estate (ADRE) 602-771-7799
            </p>
          </div>

          {/* Appointment Notice */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-8 rounded" data-id="element-971">
            <div className="flex items-start" data-id="element-972">
              <AlertCircle className="w-5 h-5 text-yellow-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-973" />
              <p className="text-base text-gray-900" data-id="element-974">
                <strong data-id="element-975">
                  As of August 30, 2024, ADRE has moved to appointment-only for
                  in-person assistance. If you would like in-person assistance,
                  please reach out using their{' '}
                  <a href="https://azre.gov/message-center" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline" data-id="element-976">
                    Message Center
                  </a>
                </strong>
              </p>
            </div>
          </div>
        </div>

        {/* QUESTIONS FOR ADRE Section */}
        <div className="bg-gray-50 px-8 py-10 mb-12 rounded-lg border border-gray-200" data-id="element-977">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-978">
            QUESTIONS FOR ADRE?
          </h2>

          <div className="space-y-6" data-id="element-979">
            {/* Message Center */}
            <div className="pb-6 border-b border-gray-200" data-id="element-980">
              <p className="text-base text-gray-900 mb-2" data-id="element-981">
                We recommend using the <strong data-id="element-982">Message Center</strong> to
                receive responses in writing for your records:
              </p>
              <a href="https://azre.gov/message-center" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 font-semibold text-lg inline-flex items-center" data-id="element-983">
                https://azre.gov/message-center
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-984" />
              </a>
            </div>

            {/* Find Your License Number */}
            <div className="pb-6 border-b border-gray-200" data-id="element-985">
              <p className="text-base font-bold italic mb-2" data-id="element-986">
                *Find Your License Number
              </p>
              <a href="http://services.azre.gov/publicdatabase/SearchIndividuals.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-987">
                http://services.azre.gov/publicdatabase/SearchIndividuals.aspx
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-988" />
              </a>
            </div>

            {/* Enter CE Classes */}
            <div className="pb-6 border-b border-gray-200" data-id="element-989">
              <p className="text-base font-bold italic mb-2" data-id="element-990">
                *Enter CE Classes
              </p>
              <p className="text-sm text-gray-600 mb-2" data-id="element-991">
                (have your license number ready to create or log in to account):
              </p>
              <a href="https://az.gov/webapp/dre/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-992">
                https://az.gov/webapp/dre/
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-993" />
              </a>
            </div>

            {/* ADRE Fee Schedule */}
            <div className="pb-6 border-b border-gray-200" data-id="element-994">
              <p className="text-base font-bold italic mb-2" data-id="element-995">
                *Fees to renew AZ real estate license:
              </p>
              <a href="https://azre.gov/all-adre-resources/fees" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-996">
                https://azre.gov/all-adre-resources/fees
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-997" />
              </a>
            </div>

            {/* Log in or update */}
            <div data-id="element-998">
              <p className="text-base font-bold italic mb-2" data-id="element-999">
                *Log in or update your personal information at ADRE or :
              </p>
              <a href="https://ptl.az.gov/app/dre/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1000">
                https://ptl.az.gov/app/dre/
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-1001" />
              </a>
            </div>
          </div>
        </div>

        {/* Tech Helpline Section */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1002">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-6" data-id="element-1003">
            Tech Helpline
          </h2>

          <div className="space-y-4" data-id="element-1004">
            <p className="text-lg text-gray-900" data-id="element-1005">
              Did you know that you can get tech help for ALL of your devices?
            </p>
            <p className="text-lg text-gray-900 ml-10" data-id="element-1006">
              It's "free"... paid for with your{' '}
              <strong data-id="element-1007">
                REALTOR<sup data-id="element-1008">®</sup>
              </strong>{' '}
              dues!
            </p>

            <div className="mt-6 bg-gray-50 p-6 rounded-lg" data-id="element-1009">
              <p className="text-base font-bold text-gray-900 mb-3" data-id="element-1010">
                Contact Tech HelpLine:
              </p>
              <div className="space-y-2" data-id="element-1011">
                <p className="text-base text-gray-900" data-id="element-1012">
                  <strong data-id="element-1013">Phone:</strong> (866) 232-1791
                </p>
                <p className="text-base text-gray-900" data-id="element-1014">
                  <strong data-id="element-1015">Online chat or support:</strong>{' '}
                  <a href="http://chat.techhelpline.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline" data-id="element-1016">
                    http://chat.techhelpline.com
                  </a>
                </p>
              </div>
            </div>

            <div className="mt-6 bg-gray-50 p-6 rounded-lg" data-id="element-1017">
              <p className="text-base font-bold text-gray-900 mb-3" data-id="element-1018">Hours:</p>
              <div className="space-y-1" data-id="element-1019">
                <p className="text-base text-gray-900" data-id="element-1020">
                  Monday through Friday—9 am to 8 pm, Eastern Time
                </p>
                <p className="text-base text-gray-900" data-id="element-1021">
                  Saturday—9 am to 5 pm, Eastern Time
                </p>
                <p className="text-base text-gray-900" data-id="element-1022">Sunday—closed</p>
              </div>
            </div>
          </div>
        </div>

        {/* Residential Landlord/Tenant Act Section */}
        <div className="bg-gray-50 px-8 py-10 mb-12 rounded-lg border border-gray-200" data-id="element-1023">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1024">
            <a href="https://housing.az.gov/sites/default/files/documents/files/Landlord_Tenant_Act_May-2023_1.pdf" target="_blank" rel="noopener noreferrer" className="text-[#fcb53d] hover:text-[#e5a436] inline-flex items-center" data-id="element-1025">
              Residential Landlord/Tenant Act
              <ExternalLink className="w-5 h-5 ml-2" data-id="element-1026" />
            </a>
          </h2>

          <p className="text-base text-gray-700" data-id="element-1027">
            This is the text of the Arizona Statute that provides the rights and
            obligations of landlords and tenants in residential properties.
          </p>
        </div>

        {/* Other Useful Sites Section */}
        <div className="mb-12" data-id="element-1028">
          <h2 className="text-3xl font-bold text-[#fcb53d] mb-8" data-id="element-1029">
            Other Useful Sites-click for links:
          </h2>

          {/* Federal Government/National Sites */}
          <div className="mb-10 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1030">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1031">
              Federal Government/National Sites
            </h3>
            <ul className="space-y-3" data-id="element-1032">
              <li className="text-base" data-id="element-1033">
                <a href="https://www.consumerfinance.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1034">
                  Consumer Financial Protection Bureau (CFPB)
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1035" />
                </a>
              </li>
              <li className="text-base" data-id="element-1036">
                <a href="https://www.hud.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1037">
                  US Department of Housing and Urban Development (HUD)
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1038" />
                </a>
              </li>
              <li className="text-base" data-id="element-1039">
                <a href="https://www.donotcall.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1040">
                  National Do Not Call Registry
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1041" />
                </a>
              </li>
              <li className="text-base" data-id="element-1042">
                <a href="https://www.va.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1043">
                  Department of Veterans Affairs
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1044" />
                </a>
              </li>
              <li className="text-base" data-id="element-1045">
                <a href="https://www.hudhomestore.com/Home/Index.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1046">
                  HUD Home Store
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1047" />
                </a>{' '}
                <span className="text-gray-600" data-id="element-1048">
                  (to sell HUD foreclosed properties, check with your broker)
                </span>
              </li>
            </ul>
          </div>

          {/* State of Arizona Sites */}
          <div className="mb-10 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1049">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1050">
              State of Arizona Sites
            </h3>
            <ul className="space-y-3" data-id="element-1051">
              <li className="text-base" data-id="element-1052">
                <a href="https://az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1053">
                  State of Arizona
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1054" />
                </a>
              </li>
              <li className="text-base" data-id="element-1055">
                <a href="https://difi.az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1056">
                  Department of Financial Institutions
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1057" />
                </a>
              </li>
              <li className="text-base" data-id="element-1058">
                <a href="http://www.azdeq.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1059">
                  Arizona Department of Environmental Quality
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1060" />
                </a>
              </li>
              <li className="text-base" data-id="element-1061">
                <a href="https://azdohs.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1062">
                  Arizona Department of Homeland Security
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1063" />
                </a>
              </li>
              <li className="text-base" data-id="element-1064">
                <a href="https://roc.az.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1065">
                  Arizona Registrar of Contractors
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1066" />
                </a>
              </li>
              <li className="text-base" data-id="element-1067">
                <a href="http://www.azcc.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1068">
                  Arizona Corporation Commission
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1069" />
                </a>
              </li>
              <li className="text-base" data-id="element-1070">
                <a href="https://azsos.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1071">
                  Arizona Secretary of State
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1072" />
                </a>
              </li>
              <li className="text-base" data-id="element-1073">
                <a href="https://www.azag.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1074">
                  Arizona Attorney General
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1075" />
                </a>
              </li>
            </ul>
          </div>

          {/* Arizona County Sites */}
          <div className="bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-1076">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1077">
              Arizona County Sites (partial list)
            </h3>
            <ul className="space-y-3" data-id="element-1078">
              <li className="text-base" data-id="element-1079">
                <a href="http://www.coconino.az.gov/119/Assessor" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1080">
                  Coconino County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1081" />
                </a>
              </li>
              <li className="text-base" data-id="element-1082">
                <a href="http://www.coconino.az.gov/319/Recorder" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1083">
                  Coconino County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1084" />
                </a>
              </li>
              <li className="text-base" data-id="element-1085">
                <a href="https://mcassessor.maricopa.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1086">
                  Maricopa County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1087" />
                </a>
              </li>
              <li className="text-base" data-id="element-1088">
                <a href="https://recorder.maricopa.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1089">
                  Maricopa County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1090" />
                </a>
              </li>
              <li className="text-base" data-id="element-1091">
                <a href="http://www.asr.pima.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1092">
                  Pima County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1093" />
                </a>
              </li>
              <li className="text-base" data-id="element-1094">
                <a href="https://www.recorder.pima.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1095">
                  Pima County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1096" />
                </a>
              </li>
              <li className="text-base" data-id="element-1097">
                <a href="http://www.pinalcountyaz.gov/Assessor/Pages/home.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1098">
                  Pinal County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1099" />
                </a>
              </li>
              <li className="text-base" data-id="element-1100">
                <a href="http://www.pinalcountyaz.gov/Recorder/Pages/home.aspx" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1101">
                  Pinal County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1102" />
                </a>
              </li>
              <li className="text-base" data-id="element-1103">
                <a href="http://www.yumacountyaz.gov/government/assessor" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1104">
                  Yuma County Assessors Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1105" />
                </a>
              </li>
              <li className="text-base" data-id="element-1106">
                <a href="http://www.yumacountyaz.gov/government/recorder" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 inline-flex items-center" data-id="element-1107">
                  Yuma County Recorders Office
                  <ExternalLink className="w-4 h-4 ml-1" data-id="element-1108" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}